import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';

import actions from './saveOrderSearch.actions.js';
import getters from './saveOrderSearch.getters.js';
import mutations from './saveOrderSearch.mutations.js';
import state from './saveOrderSearch.state.js';

BaseStore.registerModule('saveOrderSearch', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('saveOrderSearch');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
